module.exports = __webpack_public_path__ + "assets/img/line3.a9a5fb73.png";